import { ReactNode, useState } from 'react'
import { Box, Container, useMediaQuery, useTheme } from '@mui/material'
import Header from './Header'
import Sidebar from './Sidebar'
import Footer from './Footer'

interface LayoutProps {
  children: ReactNode
}

const Layout = ({ children }: LayoutProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [mobileOpen, setMobileOpen] = useState(false)

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev)
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', minHeight: '100vh' }}>
      <Header onMenuToggle={handleDrawerToggle} />
      <Box sx={{ display: 'flex', flex: 1 }}>
        <Sidebar
          variant={isMobile ? 'temporary' : 'permanent'}
          open={isMobile ? mobileOpen : true}
          onClose={isMobile ? handleDrawerToggle : undefined}
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 2, md: 3 },
            backgroundColor: 'background.default',
            minHeight: 'calc(100vh - 64px)',
            mt: { xs: '56px', md: 0 },
          }}
        >
          <Container maxWidth="xl" sx={{ pb: 4 }}>
            {children}
          </Container>
          <Footer />
        </Box>
      </Box>
    </Box>
  )
}

export default Layout

